import React from 'react';
import { ProductInfo } from '../../../types/product';

interface ProductInfoSectionProps {
  value: ProductInfo;
  onChange: (value: ProductInfo) => void;
}

// 旧 styled 定義をそのまま Tailwind クラス文字列にした定数（sections 共通の見た目）。
const SECTION = 'bg-white border border-[#e0e0e0] rounded-lg p-6 mb-6';
const SECTION_TITLE = 'm-0 mb-2 text-[18px] font-semibold text-[#333]';
const SECTION_DESCRIPTION = 'm-0 mb-6 text-[14px] text-[#666]';
const FIELD_GROUP = 'mb-5 last:mb-0';
const LABEL = 'block mb-2 text-[14px] font-semibold text-[#333]';
const INPUT =
  'w-full px-3 py-2.5 border border-[#ddd] rounded-md text-[14px] transition-[border-color] duration-200 ease-[ease] focus:outline-none focus:border-[#4CAF50]';
const TEXTAREA =
  'w-full px-3 py-2.5 border border-[#ddd] rounded-md text-[14px] [font-family:inherit] resize-y transition-[border-color] duration-200 ease-[ease] focus:outline-none focus:border-[#4CAF50]';

export const ProductInfoSection: React.FC<ProductInfoSectionProps> = ({
  value,
  onChange
}) => {
  const handleChange = (field: keyof ProductInfo, fieldValue: string) => {
    onChange({ ...value, [field]: fieldValue });
  };

  return (
    <div className={SECTION}>
      <h3 className={SECTION_TITLE}>商品基本情報</h3>
      <p className={SECTION_DESCRIPTION}>
        商品の基本的なマーケティング情報を入力してください
      </p>

      <div className={FIELD_GROUP}>
        <label className={LABEL}>商品名</label>
        <input
          className={INPUT}
          type="text"
          value={value.name || ''}
          onChange={(e) => handleChange('name', e.target.value)}
          placeholder="例: AquaX ウォーターサーバー"
          maxLength={255}
        />
      </div>

      <div className={FIELD_GROUP}>
        <label className={LABEL}>ブランド名</label>
        <input
          className={INPUT}
          type="text"
          value={value.brand || ''}
          onChange={(e) => handleChange('brand', e.target.value)}
          placeholder="例: AquaX"
          maxLength={255}
        />
      </div>

      <div className={FIELD_GROUP}>
        <label className={LABEL}>カテゴリ</label>
        <input
          className={INPUT}
          type="text"
          value={value.category || ''}
          onChange={(e) => handleChange('category', e.target.value)}
          placeholder="例: ウォーターサーバー"
          maxLength={255}
        />
      </div>

      <div className={FIELD_GROUP}>
        <label className={LABEL}>市場タイプ</label>
        <input
          className={INPUT}
          type="text"
          value={value.market_type || ''}
          onChange={(e) => handleChange('market_type', e.target.value)}
          placeholder="例: B2C"
          maxLength={100}
        />
      </div>

      <div className={FIELD_GROUP}>
        <label className={LABEL}>販売モデル</label>
        <input
          className={INPUT}
          type="text"
          value={value.sales_model || ''}
          onChange={(e) => handleChange('sales_model', e.target.value)}
          placeholder="例: サブスクリプション"
          maxLength={100}
        />
      </div>

      <div className={FIELD_GROUP}>
        <label className={LABEL}>キャッチコピー</label>
        <input
          className={INPUT}
          type="text"
          value={value.tagline || ''}
          onChange={(e) => handleChange('tagline', e.target.value)}
          placeholder="例: 手間ゼロで、家族の「いつも」を清潔に。"
          maxLength={500}
        />
      </div>

      <div className={FIELD_GROUP}>
        <label className={LABEL}>商品説明</label>
        <textarea
          className={TEXTAREA}
          value={value.description || ''}
          onChange={(e) => handleChange('description', e.target.value)}
          placeholder="商品の詳細な説明を入力してください"
          rows={4}
        />
      </div>

      <div className={FIELD_GROUP}>
        <label className={LABEL}>USP（独自の強み）</label>
        <input
          className={INPUT}
          type="text"
          value={value.usp || ''}
          onChange={(e) => handleChange('usp', e.target.value)}
          placeholder="例: 停電時も常温供給可能"
          maxLength={500}
        />
      </div>

      <div className={FIELD_GROUP}>
        <label className={LABEL}>開発体制</label>
        <textarea
          className={TEXTAREA}
          value={value.development_structure || ''}
          onChange={(e) => handleChange('development_structure', e.target.value)}
          placeholder="開発体制について記述してください"
          rows={3}
        />
      </div>

      <div className={FIELD_GROUP}>
        <label className={LABEL}>使用シーン</label>
        <textarea
          className={TEXTAREA}
          value={value.use_scenarios || ''}
          onChange={(e) => handleChange('use_scenarios', e.target.value)}
          placeholder="想定される使用シーンを記述してください"
          rows={3}
        />
      </div>

      <div className={FIELD_GROUP}>
        <label className={LABEL}>バリエーション</label>
        <textarea
          className={TEXTAREA}
          value={value.variations || ''}
          onChange={(e) => handleChange('variations', e.target.value)}
          placeholder="商品のバリエーションについて記述してください"
          rows={3}
        />
      </div>
    </div>
  );
};
